@if (variant() === 'primary') {
  <button
    class="active-press flex w-full cursor-pointer items-center justify-center gap-3 rounded-xl bg-tertiary px-8 py-6 font-headline-md text-headline-md text-on-tertiary shadow-[0_8px_0_0_var(--color-tertiary-container)] transition-all hover:brightness-110"
  >
    <span class="material-symbols-outlined neon-glow-yellow" style="font-variation-settings: 'FILL' 1">{{
      icon()
    }}</span>
    {{ label() }}
  </button>
} @else {
  <button
    class="active-press flex w-full cursor-pointer items-center gap-4 rounded-xl border border-white/5 bg-surface-container-high/50 px-6 py-5 text-left transition-all hover:brightness-110"
  >
    <span
      class="material-symbols-outlined neon-glow-cyan text-secondary-fixed-dim"
      style="font-variation-settings: 'FILL' 1"
      >{{ icon() }}</span
    >
    <span class="flex flex-col">
      <span class="font-headline-md text-headline-md text-on-surface">{{ label() }}</span>
      @if (subtitle()) {
        <span class="font-body-md text-body-md text-on-surface-variant">{{ subtitle() }}</span>
      }
    </span>
  </button>
}
